'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Field = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('@esnpm/translate');

var _index = require('./inputs/index');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// @connect(state => (state), null, null, {withRef: true})
// @connect(state => (state))
var Field = (_temp = _class = function (_React$Component) {
	_inherits(Field, _React$Component);

	function Field(props) {
		_classCallCheck(this, Field);

		var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props));

		_this.validators = [];
		_this.state = {
			value: _this.props.value,
			valid: _this.isValid(_this.props.value)
		};
		_this.input = null;
		return _this;
	}

	_createClass(Field, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			this.context.esForm.registerField(this);
			if (this.props.validators != null) {
				this.props.validators.map(function (v) {
					_this2.registerValidator(v);
				});
			}
			this.props.onRef(this);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.context.esForm.unRegisterField(this);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var _this3 = this;

			if (this.props.setInvalid !== nextProps.setInvalid) {
				if (nextProps.setInvalid) {
					_bluebird2.default.resolve(this.setState({
						valid: false
					})).then(function () {
						_this3.props.onValidChange(false);
						_this3.context.esForm.handleFieldValidChange(_this3, false);
					});
				} else {
					this.handleOnChange(this.state.value);
				}
			} else if (this.props.value !== nextProps.value) {
				_bluebird2.default.resolve(this.handleOnChange(nextProps.value)).then(function () {
					//abfrage falls input nicht mehr gemountet ist.
					if (_this3 != undefined && _this3.input != null) {
						_this3.input.setVal(nextProps.value);
					}
				});
			}
		}
	}, {
		key: 'registerValidator',
		value: function registerValidator(v) {
			if (this.validators.indexOf(v) < 0) {
				this.validators.push(v);
			}
			this.setState({ valid: this.isValid(this.props.value) });
		}
	}, {
		key: 'registerInput',
		value: function registerInput(input) {
			// console.log("registerInput"+this.props.fieldName)
			this.input = input;
		}
	}, {
		key: 'unregisterInput',
		value: function unregisterInput(input) {
			this.input = null;
		}
	}, {
		key: 'getInputProps',
		value: function getInputProps() {
			var props = {
				// ref: 'esInput',
				onChange: this.handleOnChange.bind(this),
				value: this.state.value,
				// allowedCharacters: this.props.allowedCharacters,
				className: (0, _classnames2.default)(this.props.className),
				autoFocus: this.props.autoFocus,
				placeHolder: this.props.placeHolder,
				trPlaceHolder: this.props.trPlaceHolder,
				noPlaceHolder: this.props.noPlaceHolder,
				readOnly: this.props.readOnly,
				onEnter: this.props.onEnter,
				bsSize: this.props.bsSize,
				disabled: this.props.disabled,
				noValidationClassChange: this.props.noValidationClassChange || this.context.esForm.props.noValidationClassChange,
				noValidationLabelClassChange: this.props.noValidationLabelClassChange || this.context.esForm.props.noValidationLabelClassChange,
				ref: "input",
				esFormField: this,
				size: this.props.size,
				maxLength: this.props.maxLength,
				fieldName: this.props.fieldName,
				noStrip: this.props.noStrip
			};
			return props;
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.context.esForm.props.horizontal) {
				return _react2.default.createElement(
					_react.Fragment,
					null,
					_react2.default.createElement(
						'tr',
						{ className: 'ESFormGroup' },
						this.renderLabel(),
						this.renderInputPart()
					)
				);
			} else {
				return _react2.default.createElement(
					_react.Fragment,
					null,
					_react2.default.createElement(
						'tr',
						{ className: 'ESFormGroup Label' },
						this.renderLabel()
					),
					_react2.default.createElement(
						'tr',
						{ className: 'ESFormGroup' },
						this.renderInputPart()
					)
				);
			}
		}
	}, {
		key: 'getLabelClasses',
		value: function getLabelClasses() {
			var classes = {};
			var validChange = this.props.noValidationLabelClassChange || this.context.esForm.props.noValidationLabelClassChange || this.props.disabled;
			if (!this.isEmpty()) {

				if (!validChange) {
					var _classNames;

					var classValid = this.props.classValid != null ? this.props.classValid : this.context.esForm.props.classValid;
					var classInValid = this.props.classInValid != null ? this.props.classInValid : this.context.esForm.props.classInValid;

					classes = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, classValid, this.state.valid), _defineProperty(_classNames, classInValid, !this.state.valid), _classNames));
				}
			}
			if (this.props.optional) {
				classes = (0, _classnames2.default)(classes, "Optional");
			}
			return classes;
		}
	}, {
		key: 'getInputClasses',
		value: function getInputClasses() {
			var classes = {};
			var validChange = this.props.noValidationClassChange || this.context.esForm.props.noValidationClassChange || this.props.disabled;

			if (!this.isEmpty()) {

				if (!validChange) {
					var _classNames2;

					var classValid = this.props.classValid != null ? this.props.classValid : this.context.esForm.props.classValid;
					var classInValid = this.props.classInValid != null ? this.props.classInValid : this.context.esForm.props.classInValid;

					classes = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, classValid, this.state.valid), _defineProperty(_classNames2, classInValid, !this.state.valid), _classNames2));
				}
			}
			if (this.props.optional) {
				classes = (0, _classnames2.default)(classes, "Optional");
			}
			return classes;
		}
	}, {
		key: 'renderLabelOptionalHint',
		value: function renderLabelOptionalHint() {
			return _react2.default.createElement(
				'span',
				{ className: "OptionalHint" },
				_react2.default.createElement(_translate.Tr, { path: "esforms.fields.OPTIONAL" })
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			if (this.context.esForm.props.horizontal && this.props.noLabel) return _react2.default.createElement('td', null);
			if (this.props.noLabel) return null;
			var labelText = this.props.label;
			var classes = (0, _classnames2.default)('ESFieldLabel', this.getLabelClasses());
			return _react2.default.createElement(
				'td',
				{ className: classes },
				_react2.default.createElement(
					'span',
					null,
					labelText
				),
				this.props.optional && !this.props.noOptionalLabel ? this.renderLabelOptionalHint() : null
			);
		}
	}, {
		key: 'renderInputPart',
		value: function renderInputPart() {
			var _this4 = this;

			var props = this.getInputProps();

			if (this.props.allowedCharacters != '') {
				props['allowedCharacters'] = this.props.allowedCharacters;
			}
			props['onFocus'] = function () {
				_this4.setFormFocus();
			};

			var classes = (0, _classnames2.default)('ESFieldInput', this.getInputClasses());
			return _react2.default.createElement(
				'td',
				{ className: classes },
				this.renderInput(props),
				this.renderHint()
			);
		}
	}, {
		key: 'renderHint',
		value: function renderHint() {
			if (this.props.noHint) return null;
			if (this.state.valid) return null;
			if (this.context.esForm.state.focus != this.props.fieldName) return null;

			if (this.isEmpty()) return null;

			var trHint = this.props.trHint != null ? _react2.default.createElement(_translate.Tr, { path: this.props.trHint }) : this.props.hint;

			var validClasses = {};
			var validChange = this.props.noValidationClassChange || this.context.esForm.props.noValidationClassChange;

			if (!validChange) {
				var _classNames3;

				var classValid = this.props.classValid != null ? this.props.classValid : this.context.esForm.props.classValid;
				var classInValid = this.props.classInValid != null ? this.props.classInValid : this.context.esForm.props.classInValid;

				validClasses = (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, classValid, this.state.valid), _defineProperty(_classNames3, classInValid, !this.state.valid), _classNames3));
			}
			// const classes = classNames("alert", validClasses);
			var classes = (0, _classnames2.default)(this.context.esForm.props.classHint);

			return _react2.default.createElement(
				'div',
				{ className: 'ESFieldHint' },
				_react2.default.createElement(
					'div',
					{ className: classes },
					trHint
				)
			);
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty() {
			return this.state.value == this.props.optionalEmpty;
		}
	}, {
		key: 'renderInput',
		value: function renderInput(props) {
			return _react2.default.createElement(_index.ESInput.Text, props);
		}
	}, {
		key: 'setFormFocus',
		value: function setFormFocus() {
			this.context.esForm.setFocus(this.props.fieldName);
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.setFormFocus();
			this.input.focus();
		}
	}, {
		key: 'handleOnChange',
		value: function handleOnChange(value) {
			var _this5 = this;

			var oldvalid = this.state.valid;
			// console.log("handleonchange  this.props.setInvalid----> ", this.props.setInvalid)
			var valid = this.isValid(value);
			// console.log('onChange', this.props.fieldName, this.returnValue(value));
			_bluebird2.default.resolve(this.setState({
				valid: valid,
				value: this.returnValue(value)
			})).then(function () {
				if (oldvalid != valid) {
					_this5.props.onValidChange(valid);
					_this5.context.esForm.handleFieldValidChange(_this5, valid);
				}
				_this5.props.onChange(value);
			});
		}

		//wird vom Number Input Benutzt um das Feld auf invalid zu setzen. Wenn der Wert ausserhalb von min und max liegt

	}, {
		key: 'setValid',
		value: function setValid(value, _setValid) {
			var _this6 = this;

			var oldvalid = this.state.valid;
			var valid = _setValid;
			_bluebird2.default.resolve(this.setState({
				valid: valid,
				value: this.returnValue(value)
			})).then(function () {
				if (oldvalid != valid) {
					_this6.props.onValidChange(valid);
					_this6.context.esForm.handleFieldValidChange(_this6, valid);
				}
				_this6.props.onChange(value);
			});
		}
	}, {
		key: 'isValid',
		value: function isValid(val) {

			if (this.props.optional) {
				if (this.props.optionalEmpty != null) {
					if (this.props.optionalEmpty === val) {
						return true;
					}
				} else {
					return true;
				}
			}
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var validator = _step.value;

					// console.log("validator---> ", validator.validate(val), "val---> ", val)
					if (!validator.validate(val)) return false;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (typeof val == "boolean") {
				return val;
			}
			return true;
		}

		//wird vom Field benutzt im OnChange

	}, {
		key: 'returnValue',
		value: function returnValue(val) {
			if (this.props.optional) {
				if (this.props.optionalReturnEmptyNull) {
					if (this.props.optionalEmpty != null) {
						if (this.props.optionalEmpty == val) {
							return null;
						}
					}
				}
			}
			return val;
		}

		//wird vom ESForm benutzt zum auslesen der Werte

	}, {
		key: 'getValue',
		value: function getValue() {
			if (!this.props.notFormIncluded) {
				if (typeof this.state.value == "string" && !this.props.noStrip) {
					return this.state.value.trim();
				}
				return this.state.value;
			} else {
				return null;
			}
		}

		//wird unter anderem zum reseten des formulars benutzt

	}, {
		key: 'setValFromExtern',
		value: function setValFromExtern(val) {
			this.input.setVal(val);
		}
	}]);

	return Field;
}(_react2.default.Component), _class.defaultProps = {
	noLabel: false,
	pattern: null,
	optional: false,
	noOptionalLabel: false,
	optionalEmpty: null,
	optionalReturnEmptyNull: false,
	validators: [],
	notFormIncluded: false,
	onValidChange: function onValidChange() {},
	onChange: function onChange() {},
	onEnter: function onEnter() {},
	onRef: function onRef(ref) {},
	classValid: null,
	classInValid: null,
	noValidationClassChange: false,
	noValidationLabelClassChange: false,
	allowedCharacters: '',
	label: null,
	noPlaceHolder: false,
	placeHolder: null,
	trPlaceHolder: null,
	readOnly: false,
	noHint: false,
	trHint: null,
	bsSize: null,
	disabled: false,
	autoFocus: false,
	size: null,
	maxLength: null,
	setInvalid: false,
	noStrip: false
}, _class.propTypes = {
	fieldName: _propTypes2.default.string.isRequired,
	name: _propTypes2.default.any,
	label: _propTypes2.default.any,
	noLabel: _propTypes2.default.bool,
	optional: _propTypes2.default.bool,
	noOptionalLabel: _propTypes2.default.bool,
	notFormIncluded: _propTypes2.default.bool,
	optionalEmpty: _propTypes2.default.any,
	optionalReturnEmptyNull: _propTypes2.default.bool,
	noValidationClassChange: _propTypes2.default.bool,
	pattern: _propTypes2.default.any,
	placeHolder: _propTypes2.default.any,
	trPlaceHolder: _propTypes2.default.any,
	validators: _propTypes2.default.array,
	onValidChange: _propTypes2.default.func,
	allowedCharacters: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	onRef: _propTypes2.default.func,
	onEnter: _propTypes2.default.func,
	noHint: _propTypes2.default.bool,
	trHint: _propTypes2.default.string,
	readOnly: _propTypes2.default.bool,
	bsSize: _propTypes2.default.string,
	disabled: _propTypes2.default.bool,
	autoFocus: _propTypes2.default.bool,
	size: _propTypes2.default.number,
	maxLength: _propTypes2.default.number,
	setInvalid: _propTypes2.default.bool,
	noStrip: _propTypes2.default.bool
}, _class.contextTypes = {
	esForm: _propTypes2.default.object
}, _temp);
exports.Field = Field;